import React, {  useState } from "react";
import { SimpleTable } from "../../ui/SimpleTable/SimpleTable";
import { TypeContainerPlatforms } from "../../../../../types/api/guide/typeContainerPlatform.types";
import { useFetchAllTypeContainerPlatforms } from "../../../../../hooks/guide/useFetchAllTypeContainerPlatforms";
import { ConfirmDialog } from "../../ConfirmDialog/ConfirmDialog";
import { typeContainerPlatformsService } from "../../../../../services/guide/typeContainerPlatforms-service";

import {TypeCPAddModal} from "../../ui/EntityModal/TypeCPAddModal";
import useAppSnackbar from "../../../../../hooks/useAppSnackbar";

interface ContainerSitesTypesProps {
    title: string;
}

export const ContainerSitesTypesTable = ({ title }: ContainerSitesTypesProps) => {
    const { data: typeContainerPlatforms, refetch } = useFetchAllTypeContainerPlatforms();
    const [isOpenAdd, setOpenAdd] = useState<{ isOpen: boolean, id: string }>({isOpen: false, id: ""});
    const [toDelete, setToDelete] = useState<TypeContainerPlatforms | null>(null);
    const { showSuccess, showError, SnackbarComponent } = useAppSnackbar();

    const handleDelete = async (id: string) => {
        try {
            await typeContainerPlatformsService.delete(id);
            showSuccess("Успешное удаление")
        } catch (e) {
            showError(e.response.data);
            console.log("Ошибка при удалении типа контейнера");
        }
    };

    return (
        <>
            <SimpleTable<TypeContainerPlatforms>
                title={title}
                columns={[{ key: "name", title: "Название" }]}
                data={typeContainerPlatforms}
                enableSearchByName
                getRowKey={(r) => r.id}
                getRowActions={(row) => ({
                    onEdit: () => setOpenAdd({isOpen: true, id: row.id}),
                    onDelete: () => setToDelete(row)
                })}
                emptyText="Справочник пуст"
                setOpen={() => setOpenAdd({isOpen: true, id: ""})}
            />
            <ConfirmDialog
                open={!!toDelete}
                title="Удалить тип контейнерной площадки?"
                description={toDelete ? `Будет удалена: ${toDelete.name}` : undefined}
                onCancel={() => setToDelete(null)}
                onConfirm={() => {
                    if (!toDelete) return;
                    handleDelete(toDelete.id);
                    setToDelete(null);
                }}
            />

            {
                isOpenAdd.isOpen && (
                    <TypeCPAddModal onClose={() => setOpenAdd({isOpen: false, id: ""})} id={isOpenAdd.id} refetchData={refetch} />
                )
            }
            <SnackbarComponent/>
        </>
    );
};
